import React, { useState } from "react";
import PropTypes from "prop-types";
//import { Redirect, withRouter  } from "react-router-dom";
import { InputGroup, ControlGroup, Button } from "@blueprintjs/core";
import "./Login.css";

import { useTranslation } from 'react-i18next';

require('dotenv').config();

const Login = ({ login }) => {
    const [username, setusername] = useState(""); // useState("TestUser");
    const [password, setPassword] = useState(""); //useState("test2021");
      const [error, setError] = useState("");

    const { t } = useTranslation();
    
    const doLogin = async (e, username, password) => {
        e.preventDefault();
        try {
            const response = await login(username, password);
            if (!response) setError("Failed to login ");
        } catch (e) {
          setError("Failed to login", e.message);
        }
      };

    return (
        <div className="parent">
            <h1>Login</h1>
            <ControlGroup className="login" fill={true} vertical={true}>
                <form onSubmit={(e) => doLogin(e, username, password)}>
                    <InputGroup className="input" id="username" placeholder=" Username" value={username} onChange={(e) => { setusername(e.target.value); setError(""); }} />
                    <InputGroup className="input" id="password" type="password" placeholder="Password" autoComplete="true" value={password} onChange={(e) => { setPassword(e.target.value); setError(""); }} />
                    
                    <Button className="loginButton" type="submit" intent="primary" disabled={username === "" || password === ""} text={t("Login")} />
                    </form>
            </ControlGroup>
            {error !== "" ? <span className="error"> {error} </span> : ""}
        </div>
    );
};


Login.propTypes = {

};

export default Login;

/*<span> {t("Change password")} </span> <br /> */